import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import {ChallengeInApp} from "../../models/challenge-in-app";
import {AlertController, Events, NavController} from "ionic-angular";
import {UserStats} from "../api-course-data/user-state-dto";
import {User, UserStateProvider} from "../user-state/user-state";
import {ContentTranslationProvider} from "../content-translation/content-translation";
import {AppChallengeInAppPage} from "../../pages/app-challenge-in-app/app-challenge-in-app";
import {ChallengeUser} from "../../models/challenge-user";

/*
  Generated class for the ChallengeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ChallengeProvider {

  challengesInApp: Array<ChallengeInApp>
  challengesUser: Array<ChallengeUser>

  challengePopupMuted: boolean = true;

  constructor(
    private api: ApiProvider,
    private userState: UserStateProvider,
    public events: Events,
    private alertCtrl: AlertController,
    private contentTranslation: ContentTranslationProvider,
  ) {
    (window as any).eventDebugger = events;
    this.events.subscribe('video:watched', (params) => {this.handleEvent('video:watched', params)});
    this.events.subscribe('activity:tracked', (params) => {this.handleEvent('activity:tracked', params)});
    this.events.subscribe('activity:goalUpdated', (params) => {this.handleEvent('activity:goalUpdated', params)});
    this.events.subscribe('stats:food:completed', (params) => {this.handleEvent('stats:food:completed', params)});
    this.events.subscribe('stats:food:second-row-filled', (params) => {this.handleEvent('stats:food:second-row-filled', params)});
    this.events.subscribe('my-way:filled', (params) => {this.handleEvent('my-way:filled', params)});
    this.events.subscribe('training:notificationEnabled', (params) => {this.handleEvent('training:notificationEnabled', params)});
    this.events.subscribe('module:finished', (params) => {this.handleEvent('module:finished', params)});
    this.events.subscribe('stats:activityFilledNDaysInRow', (params) => {this.handleEvent('stats:activityFilledNDaysInRow', params)});
    this.events.subscribe('stats:food:update', (params) => {this.handleEvent('stats:food:update', params)});
    this.events.subscribe('activity:goalReached', (params) => {this.handleEvent('activity:goalReached', params)});
    this.events.subscribe('stats:food:completedNDays', (params) => {this.handleEvent('stats:food:completedNDays', params)});
    this.events.subscribe('mood:tracked', (params) => {this.handleEvent('mood:tracked', params)});
    this.events.subscribe('stats:activityLongerThanYesterday', (params) => {this.handleEvent('stats:activityLongerThanYesterday', params)});
    this.events.subscribe('stats:activityLongerThanYesterday10', (params) => {this.handleEvent('stats:activityLongerThanYesterday10', params)});
    this.events.subscribe('stats:stepsIncreased3000', (params) => {this.handleEvent('stats:stepsIncreased3000', params)});
    this.events.subscribe('stats:stepsIncreased5000', (params) => {this.handleEvent('stats:stepsIncreased5000', params)});
    this.events.subscribe('forum:response', (params) => {this.handleEvent('forum:response', params)});
    this.events.subscribe('stats:steps5000', (params) => {this.handleEvent('stats:steps5000', params)});
    this.events.subscribe('stats:weightGoalUpdated', (params) => {this.handleEvent('stats:weightGoalUpdated', params)});
    this.events.subscribe('stats:food:tipEmptyYesterday', (params) => {this.handleEvent('stats:food:tipEmptyYesterday', params)});
    this.events.subscribe('training:repeated', (params) => {this.handleEvent('training:repeated', params)});
    this.events.subscribe('chat:message-sent', (params) => {this.handleEvent('chat:message-sent', params)});
    this.events.subscribe('video:bonusWatched', (params) => {this.handleEvent('video:bonusWatched', params)});
    this.events.subscribe('stats:steps10000', (params) => {this.handleEvent('stats:steps10000', params)});
    this.events.subscribe('stats:food:tipEmpty7Days', (params) => {this.handleEvent('stats:food:tipEmpty7Days', params)});
    this.events.subscribe('stats:weight:goalReached', (params) => {this.handleEvent('stats:weight:goalReached', params)});
    this.events.subscribe('challenges:finished', (params) => {this.handleEvent('challenges:finished', params)});
    this.events.subscribe('stats:weight:filledDataForWeeks', (params) => {this.handleEvent('stats:weight:filledDataForWeeks', params)});
    this.events.subscribe('stats:food:secondRowIncreased', (params) => {this.handleEvent('stats:food:secondRowIncreased', params)});
  }

  isIgnored(challenge: any, user: User) {
    if (challenge.ruleForCompletion.indexOf('stats:steps') >= 0 && !user.program.stepTracking) {
      return true;
    }
    if (challenge.ruleForCompletion.indexOf('mood:') >= 0 && !user.program.moodTracking) {
      return true;
    }
    if (challenge.ruleForCompletion.indexOf('stats:weight') >= 0 && !user.program.weightTracking) {
      return true;
    }
    if (challenge.ruleForCompletion.indexOf('stats:food') >= 0 && !user.program.foodTracking) {
      return true;
    }
    return false;

  }

  private pendingEvents: Array<{eventName: string, params: any}> = [];

  handleEvent(eventName: string, params: any) {
    console.log('challenge handler', eventName, params);
    if (!this.challengesInApp) {
      this.pendingEvents.push({eventName, params});
      return ;
    }
    this.processEvent(eventName, params);
  }

  private processEvent(eventName: string, params: any) {
    for(let challenge of this.challengesInApp) {
      if (challenge._userStatus != 2 && challenge.ruleForCompletionConfig && challenge.ruleForCompletionConfig.event == eventName) {
        let success = true;
        for (let k in challenge.ruleForCompletionConfig.params) {
          if (!challenge.ruleForCompletionConfig.params || !params || params[k] != challenge.ruleForCompletionConfig.params[k]) {
            success = false;
          }
        }
        if(success) {
          challenge._userStatus = 2;
          this.api.callPost('/users/'+this.userState.user.id+"/markInAppChallenge", {
            challenge: challenge.id,
            status: 2
          }).subscribe(() => {
            challenge._userStatus = 2;
            let popup = this.showChallengeSuccessPopup(challenge);
            if (popup) {
              popup.onDidDismiss(() => {
                var notFinishedChallenges = this.challengesInApp.filter(challenge => {
                  return challenge._userStatus != 2 && !this.isIgnored(challenge, this.userState.user)
                });
                console.log('not finished challenges count', notFinishedChallenges.length)
                if(notFinishedChallenges.length == 1) {
                  this.userState.user.challengeStatus = 1;
                  this.events.publish('challenges:finished');
                }
              });
            }
            this.events.publish('state:refresh');
          })
        }
      }
    }
  }

  showChallengeSuccessPopup(challenge: ChallengeInApp) {
    var isFinal = (challenge.ruleForCompletionConfig.event == 'challenges:finished');
    if (!isFinal && this.challengePopupMuted) {
      return ;
    }
    const alertModal = this.alertCtrl.create({
      title: ('<div><img src="'+challenge.imageColorURL+'" /></div>')+(challenge.popupTitle?challenge.popupTitle:this.contentTranslation.translateContent('Challenge achieved default title')),
      subTitle: challenge.popupMessage?challenge.popupMessage:this.contentTranslation.translateContent('Challenge achieved default :name text').replace(':name', challenge.name),
      buttons: [
        {
          text: this.contentTranslation.translateContent('Challenge achieved button'),
          cssClass: 'alert-primary-button',
          handler: () => {
            if (isFinal) {
              this.events.publish('redirectToView', { page: 'challenges'})
            } else {
              this.events.publish('redirectToView', { page: 'challenge-in-app'})
            }
          }
        },
        {
          text: '×',
          cssClass: 'close-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close ip-challenge-achieved '+(isFinal?'ip-challenges-finished':'')
    });
    alertModal.present();
    return alertModal;
  }

  getInAppChallenges() {
    return this.challengesInApp;
  }

  setInAppData(challenges: Array<ChallengeInApp>) {
    console.log('setInAppData', challenges);
    for (let challenge of (challenges || [])) {
      if (challenge.id === '0ea6ec6e-745b-11ec-9464-22c7eb7aae24') {
        challenge.ruleForCompletionConfig = {event: 'stats:food:completed'};
      }
    }
    this.challengesInApp = challenges;
    while (this.pendingEvents.length > 0) {
      let pending = this.pendingEvents.shift();
      this.processEvent(pending.eventName, pending.params);
    }
  }
  getUserChallenges() {
    return this.challengesUser;
  }

  setUserChallenges(challenges: Array<ChallengeUser>) {
    this.challengesUser = challenges;
  }

  hasInAppChallengeCompleted(challengeParams) {
    let foundChallenge = null;
    console.log(this.challengesInApp);
    for (var challenge of this.challengesInApp) {
      if (JSON.stringify(challenge.ruleForCompletionConfig) == JSON.stringify(challengeParams)) {
        console.log(challenge.ruleForCompletionConfig, challengeParams);
        foundChallenge = challenge;
        break;
      }
    }

    if (foundChallenge && foundChallenge._userStatus == 2) {
      return  true;
    }
    return false;
  }

  userChallengeUpdate(challenge, payload) {
    return new Promise((callback, failure) => {
      payload['challenge'] = challenge.id;
      console.log('update challenge payload', payload, challenge);
      return this.api.callPost('/users/'+this.userState.user.id+"/updateUserChallenge", payload).subscribe((resp) => {
        for(var k in resp) {
          challenge[k] = resp[k];
        }
        callback();
        this.events.publish('state:refresh');
      }, failure);
    })
  }

  unmuteChallengePopup() {
    console.log('unmute challenge popup');
    this.challengePopupMuted = false;
  }

}



// WEBPACK FOOTER //
// ./src/providers/challenge/challenge.ts